import { useEffect, useState } from "react";
import {
  browserSupportsWebAuthn,
  platformAuthenticatorIsAvailable,
} from "@simplewebauthn/browser";

/**
 * Capability detection. Never hardcode browser names — ask the API.
 * `supported` is sync; `platformAvailable` resolves async (null while unknown).
 */
export function useWebauthnSupport() {
  const supported = browserSupportsWebAuthn();
  const [platformAvailable, setPlatformAvailable] = useState(null);

  useEffect(() => {
    let alive = true;
    if (!supported) {
      setPlatformAvailable(false);
      return;
    }
    platformAuthenticatorIsAvailable()
      .then((v) => alive && setPlatformAvailable(v))
      .catch(() => alive && setPlatformAvailable(false));
    return () => {
      alive = false;
    };
  }, [supported]);

  return { supported, platformAvailable };
}
